<template>
  <div class="advice">
    <TopContent />
    <div class="bottom">
      <div class="list">
        <div class="item" v-for="(item, index) in goalList" :key="index">
          <div class="item-dot"></div>
          <img class="item-icon" :src="item.icon_url" alt="" />
          <div class="item-title"
            ><span class="item-num">{{ index + 1 }}</span
            >{{ item.title }}</div
          >
          <div class="item-text" v-html="item.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopContent from './top-content.vue'
export default {
  components: {
    TopContent
  },
  data() {
    return {}
  },
  computed: {
    goalList() {
      let info = this.$store.state.cnaV2.resultData
      if (info) {
        let data = info.adviceList.daily_tip
        return data
      }
      return []
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.advice {
  //min-height: 100vh;
  background-color: #fff;

  .bottom {
    position: relative;
    z-index: 1;
    margin-top: -16px;
    padding: 20px;
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    overflow: hidden;

    .list {
      .item {
        position: relative;
        padding: 16px;
        background: rgba(233, 246, 252, 0.88);
        border-radius: 12px;
        margin-bottom: 20px;

        .item-dot {
          position: absolute;
          right: 20px;
          top: 8px;
          width: 31px;
          height: 31px;
          border-radius: 50%;
          overflow: hidden;
          background: #b1e5fc;
        }
        .item-icon {
          position: absolute;
          right: 16px;
          top: -12px;
          width: 49px;
          height: 49px;
          object-fit: contain;
        }

        .item-title {
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #000000;
          line-height: 21px;
          margin-bottom: 16px;

          .item-num {
            font-size: 20px;
            margin-right: 6px;
          }
        }

        .item-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 20px;
        }
      }

      .item:nth-child(2) {
        background-color: rgba(234, 246, 243, 0.88);
        .item-dot {
          background: #b5e4d2;
        }
      }

      .item:nth-child(3) {
        background-color: rgba(241, 239, 251, 0.88);
        .item-dot {
          background: #d1c5fe;
        }
      }

      .item:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
